import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import TeamManagement from './pages/TeamManagement';
import TeamApprovals from './pages/TeamApprovals';
import CreateTeam from './pages/CreateTeam';
import Players from './pages/Players';
import PlayerDetail from './pages/PlayerDetail';
import Leagues from './pages/Leagues';
import CreateLeague from './pages/CreateLeague';
import LeagueManagement from './pages/LeagueManagement';
import Matches from './pages/Matches';
import AcceptInvitation from './pages/AcceptInvitation';
import AcceptGuestInvite from './pages/AcceptGuestInvite';
import ClubDetail from './pages/ClubDetail';
import Clubs from './pages/Clubs';
import CreateClub from './pages/CreateClub';
import EditClub from './pages/EditClub';
import ClubManagement from './pages/ClubManagement';
import Stats from './pages/Stats';
import RefereeDashboard from './pages/RefereeDashboard';
import MatchCompletion from './pages/MatchCompletion';
import MatchDetail from './pages/MatchDetail';
import MatchDetailGeneral from './pages/MatchDetailGeneral';
import SelectTeam from './pages/SelectTeam';
import TeamJoinApprovals from './pages/TeamJoinApprovals';
import UserProfile from './pages/UserProfile';
import UserChangeLogs from './pages/UserChangeLogs';
import Fields from './pages/Fields';
import FieldDetail from './pages/FieldDetail';
import CreateSeason from './pages/CreateSeason';
import Seasons from './pages/Seasons';
import Tournaments from './pages/Tournaments';
import CreateTournament from './pages/CreateTournament';
import TournamentManagement from './pages/TournamentManagement';
import TournamentBracket from './pages/TournamentBracket';
import Payments from './pages/Payments';
import PaymentSuccess from './pages/PaymentSuccess';
import SeasonDetail from './pages/SeasonDetail';
import ParentDashboard from './pages/ParentDashboard';
import AdminMergeAccounts from './pages/AdminMergeAccounts';
import AdminScheduler from './pages/AdminScheduler';
import MatchDay from './pages/MatchDay';
import Terms from './pages/Terms';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <div className="container">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/terms" element={<Terms />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teams"
                element={
                  <PrivateRoute>
                    <Teams />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teams/create"
                element={
                  <PrivateRoute>
                    <CreateTeam />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teams/:id"
                element={
                  <PrivateRoute>
                    <TeamDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teams/:id/manage"
                element={
                  <PrivateRoute>
                    <TeamManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teams/approvals"
                element={
                  <PrivateRoute>
                    <TeamApprovals />
                  </PrivateRoute>
                }
              />
              <Route
                path="/players"
                element={
                  <PrivateRoute>
                    <Players />
                  </PrivateRoute>
                }
              />
              <Route
                path="/players/:id"
                element={
                  <PrivateRoute>
                    <PlayerDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/users/:id"
                element={
                  <PrivateRoute>
                    <UserProfile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/change-logs"
                element={
                  <PrivateRoute>
                    <UserChangeLogs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/leagues"
                element={
                  <PrivateRoute>
                    <Leagues />
                  </PrivateRoute>
                }
              />
              <Route
                path="/leagues/create"
                element={
                  <PrivateRoute>
                    <CreateLeague />
                  </PrivateRoute>
                }
              />
              <Route
                path="/leagues/:id/manage"
                element={
                  <PrivateRoute>
                    <LeagueManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments"
                element={
                  <PrivateRoute>
                    <Tournaments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/create"
                element={
                  <PrivateRoute>
                    <CreateTournament />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/manage"
                element={
                  <PrivateRoute>
                    <TournamentManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/bracket"
                element={
                  <PrivateRoute>
                    <TournamentBracket />
                  </PrivateRoute>
                }
              />
              <Route
                path="/matches"
                element={
                  <PrivateRoute>
                    <Matches />
                  </PrivateRoute>
                }
              />
              <Route
                path="/invitations/accept/:token"
                element={
                  <PrivateRoute>
                    <AcceptInvitation />
                  </PrivateRoute>
                }
              />
              <Route path="/guest-invite/:token" element={<AcceptGuestInvite />} />
              <Route
                path="/clubs"
                element={
                  <PrivateRoute>
                    <Clubs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clubs/create"
                element={
                  <PrivateRoute>
                    <CreateClub />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clubs/manage"
                element={
                  <PrivateRoute element={<ClubManagement />} allowedRoles={['director', 'admin', 'super_admin']} />
                }
              />
              <Route
                path="/clubs/:id/edit"
                element={
                  <PrivateRoute>
                    <EditClub />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clubs/:id"
                element={
                  <PrivateRoute>
                    <ClubDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/stats"
                element={
                  <PrivateRoute>
                    <Stats />
                  </PrivateRoute>
                }
              />
              <Route
                path="/referees/dashboard"
                element={
                  <PrivateRoute element={<RefereeDashboard />} allowedRoles={['referee']} />
                }
              />
              <Route
                path="/referees/matches/:matchId/complete"
                element={
                  <PrivateRoute element={<MatchCompletion />} allowedRoles={['referee']} />
                }
              />
              <Route
                path="/referees/matches/:matchId"
                element={
                  <PrivateRoute element={<MatchDetail />} allowedRoles={['referee']} />
                }
              />
              <Route
                path="/matches/:id"
                element={
                  <PrivateRoute>
                    <MatchDetailGeneral />
                  </PrivateRoute>
                }
              />
              <Route
                path="/players/select-team"
                element={
                  <PrivateRoute element={<SelectTeam />} allowedRoles={['player']} />
                }
              />
              <Route
                path="/team-join-approvals"
                element={
                  <PrivateRoute element={<TeamJoinApprovals />} allowedRoles={['manager', 'admin', 'super_admin']} />
                }
              />
              <Route
                path="/fields"
                element={
                  <PrivateRoute>
                    <Fields />
                  </PrivateRoute>
                }
              />
              <Route
                path="/fields/:id"
                element={
                  <PrivateRoute>
                    <FieldDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/seasons"
                element={
                  <PrivateRoute element={<Seasons />} allowedRoles={['admin', 'super_admin']} />
                }
              />
              <Route
                path="/seasons/create"
                element={
                  <PrivateRoute>
                    <CreateSeason />
                  </PrivateRoute>
                }
              />
              <Route
                path="/seasons/:id"
                element={
                  <PrivateRoute element={<SeasonDetail />} allowedRoles={['admin', 'super_admin']} />
                }
              />
              <Route
                path="/payments"
                element={
                  <PrivateRoute>
                    <Payments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/scheduler"
                element={
                  <PrivateRoute element={<AdminScheduler />} allowedRoles={['admin', 'super_admin']} />
                }
              />
              <Route
                path="/admin/merge-accounts"
                element={
                  <PrivateRoute element={<AdminMergeAccounts />} allowedRoles={['super_admin']} />
                }
              />
              <Route
                path="/match-day"
                element={
                  <PrivateRoute element={<MatchDay />} allowedRoles={['referee']} />
                }
              />
              <Route
                path="/parent-dashboard"
                element={
                  <PrivateRoute element={<ParentDashboard />} allowedRoles={['parent', 'admin', 'super_admin']} />
                }
              />
              <Route
                path="/payment-success"
                element={
                  <PrivateRoute>
                    <PaymentSuccess />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

